var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29976 5.49973C1.29976 7.81932 3.18016 9.69973 5.49976 9.69973C7.81935 9.69973 9.69976 7.81932 9.69976 5.49973C9.69976 3.18013 7.81935 1.29973 5.49976 1.29973C3.18016 1.29973 1.29976 3.18013 1.29976 5.49973ZM-0.000244141 5.49973C-0.000244141 8.53729 2.46219 10.9997 5.49976 10.9997C6.65724 10.9997 7.73121 10.6422 8.61724 10.0315L9.29314 10.7074L12.2931 13.7074L13.0002 14.4145L14.4145 13.0003L13.7074 12.2932L10.7074 9.29317L10.0315 8.61729C10.6422 7.73124 10.9998 6.65724 10.9998 5.49973C10.9998 2.46216 8.53732 -0.000274658 5.49976 -0.000274658C2.46219 -0.000274658 -0.000244141 2.46216 -0.000244141 5.49973Z",
    fill: "#202124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2dbbd485f52288d1dcc4ea85783c5572.svg";
export { ForwardRef as ReactComponent };